<template>
  <div class="daySign-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" filterable clearable>
                <el-option v-for="item in brandList" :key="item.brand_id" :label="item.brand_name" :value="item.brand_id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker
                v-model="searchForm.searchDate"
                size="small"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" icon="el-icon-plus" @click="editRow(null)">添加日签</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-col :span="24" v-loading="tableLoading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                  prop="img_url"
                  label="日签图片"
                  align="center"
                  width="150">
                  <template slot-scope="scope">
                    <el-image
                      :src="scope.row.img_url"
                      fit="contain"
                      style="width: 100%;height: 40px;"
                      :preview-src-list="[scope.row.img_url]">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  align="center"
                  width="140"
                  label="时间">
                </el-table-column>
                <el-table-column
                  prop="brandname"
                  label="品牌"
                  width="140"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="content"
                  label="日签内容"
                  min-width="140"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="操作"
                  align="center"
                  width="180">
                  <template slot-scope="scope">
                    <el-button @click.stop="editRow(scope.row)" size="mini" icon="el-icon-edit-outline" >编辑</el-button>
                    <el-button @click.stop="deleteRow(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="total>0"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </el-col>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog
      :title="form.signId===''?'添加日签':'修改日签'"
      :visible.sync="dialogVisible"
      width="55%"
      top="8vh"
      :before-close="handleClose">
        <el-form ref="form" size="small" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="品牌" prop="brandId">
            <el-select v-model="form.brandId" :clearable="true" :filterable="true" placeholder="请选择品牌">
              <el-option v-for="item in brandList" :key="item.brand_id" :label="item.brand_name" :value="item.brand_id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="time">
            <el-date-picker
              v-model="form.time"
              type="date"
              :picker-options="pickerOptions0"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="选择图片" prop="image">
            <SingleImg :key="form.round" v-model="form.image" :oldurl="form.image.imgurl"/>
          </el-form-item>
          <el-form-item label="添加内容" prop="content">
            <el-input v-model="form.content" type="textarea" :rows="5" resize="none" style="width: 90%;"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading = "btnLoading" type="primary" @click="subDaily('form')">立即提交</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDaySign} from '@/api/work'
import { addDaySign} from '@/api/work'
import { getBrandList} from '@/api/work'
import { deleteDaySign} from '@/api/work'
import SingleImg from '@/components/upload/SingleImg'
import { getUserWorkRule } from '@/api/user'

export default {
  computed: {
    user: getUser
  },
  created() {
    this.getMenu()
  },
  components:{
    SingleImg
  },
  data(){
    return{
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      searchForm: {
        searchDate: [],
        brandId: ''
      },
      tableData:[],
      tableLoading: false,
      btnLoading: false,
      beginTime: '',
      endTime: '',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      brandList: [],
      dialogVisible: false,
      form: {
        signId: 0,
        round: '',
        brandId: '',
        image: {
          imgid: '',
          imgurl: ''
        },
        title: '',
        content: '',
        time: '',
        loading: false
      },
      rules: {
        brandId:[
          {required: true, message: '请选择品牌', trigger:  ['change','blur'] }
        ],
        time:[
          {required: true, message: '请选择时间', trigger: ['change','blur'] }
        ],
        content: [
          {required: true, message: '请输入内容', trigger: 'blur' }
        ],
        image: [
          {required: true, message: '请选择图片', trigger: 'change' }
        ]
      },
      isMenu: 0
    }
  },
  methods:{
    Search(){
      if(this.searchForm.searchDate!=='' && this.searchForm.searchDate!==null){
        this.beginTime = this.searchForm.searchDate[0]
        this.endTime = this.searchForm.searchDate[1]
      }else {
        this.beginTime = ''
        this.endTime = ''
      }
      this.currentPage = 1
      this.getDaySignData()
    },
    getMenu() {
      const data = {
        userid: this.user.dUserid,
        rule: this.user.rank,
        type: 0
      }
      getUserWorkRule(data).then(response => {
        for (const m of response.data) {
          if (m.name === '企划物料') {
            for (const menu of m.menulst) {
              if (menu.dNum === 'wlzl') {
                this.isMenu = 1
                break
              }
            }
            break
          }
        }
        this.getDaySignData()
        this.getBrandList()
      })
    },
    getDaySignData(){
      this.tableLoading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        beginTime: this.beginTime,
        endTime: this.endTime,
        brandId: this.searchForm.brandId,
        groupid: this.user.dGroupid,
        isMenu: this.isMenu
      }
      getDaySign(data).then(response=>{
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      })
    },
    getBrandList(){
      getBrandList().then(response=>{
        for (const data of response.data) {
          if (this.isMenu === 1) {
            this.brandList.push(data)
          } else {
            if (this.user.dGroupid === 1) {
              if (data.brand_id === 3) {
                this.brandList.push(data)
              }
            } else {
              if (data.brand_id === 1 || data.brand_id === 2) {
                this.brandList.push(data)
              }
            }
          }
        }
      })
    },
    editRow(row){
      this.dialogVisible = true
      this.form.loading = true
      if(row!=null){
        this.form.brandId = row.bid
        this.form.content = row.content
        this.form.signId = row.did
        this.form.time = row.time
        this.form.image.imgid = row.imgid
        this.form.image.imgurl = row.img_url
      }
      this.form.round = new Date().getTime().toString();
      this.form.loading = false
    },
    deleteRow(row){
      if(row!=null){
        this.$confirm('您确定要删除这条日签吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          const data = {
            signId: row.did
          }
          deleteDaySign(data).then(response=>{
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getDaySignData()
          })
        }).catch(() => {
        });
      }
    },
    subDaily(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.btnLoading) {
            if(this.form.image.imgid===''){
              this.$message.error('请选择图片')
              return false
            }
            this.btnLoading = true
            const data = {
              signId: this.form.signId,
              time: this.form.time,
              bId: this.form.brandId,
              imgId: this.form.image.imgid,
              content: this.form.content
            }
            addDaySign(data).then(response=>{
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.btnLoading = false
              this.dialogVisible = false
              this.getDaySignData()
            }).catch(() => {
              this.btnLoading = false
            });
          }
        }
      });
    },
    /*resetForm(formName){
      this.$refs[formName].resetFields();
      this.form.image.imgurl=''
      this.form.round = Math.floor(Math.random()*(1 - 100) + 100);
    },*/
    handleSizeChange(val){
      this.pageSize = val
      this.currentPage = 1
      this.getStorageRecord()
    },
    handleCurrentChange(val){
      this.currentPage = val
      this.getStorageRecord()
    },
    handleClose(done){
      this.form.brandId = ''
      this.form.content = ''
      this.form.signId = 0
      this.form.time = ''
      this.form.image.imgid = ''
      this.form.image.imgurl = ''
      done();
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
      }
      .search-area{
        float: right;
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
